// src/context/AfipHealthContext.js
import React, { createContext, useContext } from 'react';

const AfipHealthContext = createContext({
    afipHealth: null,
    isLoading: true,
    lastUpdated: null,
    refresh: () => {},
});

export const useAfipHealth = () => {
    const ctx = useContext(AfipHealthContext);
    if (ctx === undefined) {
        throw new Error('useAfipHealth must be used within an AfipHealthProvider');
    }
    return ctx;
};

export default AfipHealthContext;
